import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import axios from "axios";
import * as React from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../asset/images/signin_new.JPG";
import ValidateEmail from "../asset/js/ValidateEmail";
import SimpleBackdrop from "./BackDrop";
import { Copyright } from "./Copyright";
import Next from "./Next";
import OTPInput from "./OTP";
import { useEffect } from "react";
import Footer from "./Footer";
import { SetMeal } from "@mui/icons-material";
import ProgressBar from "./SignUpCompo/Progressbar";
import ShowDetailSignup from "./SignUpCompo/ShowDetailsSignup";
import "./auth-modern.css";
import { trackEventOnce } from "../asset/js/analytics";
const theme = createTheme({
  typography: {
    fontFamily: [
      "Assistant",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

export default function SignUpWithPhone() {
  const isProfessionalRegistration = window.location.pathname.includes("signupasprof");
  const [direct, setDirect] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [progress, setProgress] = useState(1);

  const handleToggle = () => {
    setOpen(!open);
  };
  let prof=React.useRef(false);
  useEffect(() => {
    trackEventOnce(
      isProfessionalRegistration ? "pro_registration_started" : "registration_started",
      isProfessionalRegistration ? "professional" : "customer",
      { registration_type: isProfessionalRegistration ? "professional" : "customer" }
    );
    // Accessing the current URL
    const currentUrl = window.location.href;
    console.log('Current URL:', currentUrl);
    if(currentUrl.includes("prof"))
    prof.current=true;

    // You can perform further actions with the URL if needed
  }, []);
  const [next, setNext] = React.useState(false);
  const [otp, setotp] = useState("");
  const [token, setToken] = useState("no");
  const [which, setWhich] = useState("no");
  let email = React.useRef();
  const [phoneInput, setPhoneInput] = useState("");

  const [validEmail, setValidEmail] = React.useState(false);
  useEffect(()=>{
   
    const digits = "0123456789";
    let OTP = "";
    for (let i = 0; i < 6; i++) {
      OTP += digits[Math.floor(Math.random() * 10)];
    }
    setotp(OTP);
 
},[])
  const handleSubmit = () => {
    if (!/^05\d{8}$/.test(phoneInput)) return;
    setValidEmail(false);
    console.log(email.current);
 
    axios
    .get(
      `${process.env.React_APP_BACKEND_URL}/api/checkphone2?phone=${email.current}`
    ).then(res=>{
      const otpOrigin = typeof window !== "undefined" ? window.location.hostname : "";
      const otpMessage = otpOrigin
        ? `קוד האימות שלך הוא ${otp}\n\n@${otpOrigin} #${otp}`
        : `קוד האימות שלך הוא ${otp}`;

      axios.post(`https://api.sms4free.co.il/ApiSMS/v2/SendSMS`,{
        "key":"8aTTPFD18",
        "user":"0553181000",
        "pass":"36414431",
        "sender":"Bidit",
        "recipient":email.current,
        "msg":otpMessage
    
    }).then(res=>{
        setOpen(false);
      setNext(true);
      setDirect(true);
    }).catch(err=>console.log(err))
    }).catch(err=>{
      setValidEmail(true);
    })
    
    
  };

  const handleEmail = (e) => {
    const change = e.target.value.replace(/\D/g, "").slice(0, 10);
    setPhoneInput(change);
    email.current = change;
  };
  

  return (
    <ThemeProvider theme={theme}>
    <ProgressBar progress={progress} prof={prof.current}/>
      <Container component="main" maxWidth="xs" className="auth-modern-page">
        <CssBaseline />
        <Box
          className="auth-modern-card"
          sx={{
            fontFamily: `${process.env.REACT_APP_FONT}`,
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "100%", textAlign: "center", mb: 2.4 }}>
            <Typography
              component="span"
              sx={{
                display: "inline-flex",
                px: 1.4,
                py: 0.55,
                mb: 1.1,
                borderRadius: "999px",
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontSize: ".82rem",
                fontWeight: 900,
                color: "#0877C9",
                bgcolor: "#EAF6FE",
                border: "1px solid #CFE8F7",
              }}
            >
              הרשמה מהירה ומאובטחת
            </Typography>
            <Typography
              component="h1"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: 900,
                fontSize: { xs: "1.55rem", sm: "1.8rem" },
                lineHeight: 1.3,
                color: "#173B57",
              }}
            >
              {isProfessionalRegistration
                ? "פותחים חשבון לבעל מקצוע"
                : "בואו נפתח לך חשבון"}
            </Typography>
            <Typography
              sx={{
                mt: 0.7,
                fontFamily: `${process.env.REACT_APP_FONT}`,
                color: "#60798B",
                fontSize: ".98rem",
              }}
            >
              מתחילים באימות קצר של מספר הטלפון
            </Typography>
          </Box>
		  
          {!next && !direct && (
            <Box
              noValidate
              sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, mt: 1, width: "100%" }}
            >
			<Typography
			  variant="subtitle1"
			  sx={{
				fontFamily: `${process.env.REACT_APP_FONT}`,
				fontWeight: "bold",
				fontSize: 16,   // שנה ל-18/22 לפי הטעם
				lineHeight: 1.6
			  }}
			>
			  הזן את מספר הטלפון שלך:
			</Typography>

              <TextField
                margin="normal"
                required
                fullWidth
                sx={{
					fontFamily: `${process.env.REACT_APP_FONT}`,
					"& .MuiInputBase-input": { fontSize: 18 } // זה מגדיל רק את מה שהמשתמש מקליד
				  }}
                value={phoneInput}
                onChange={(e) => handleEmail(e)}
                id="email"
                name="email"
                autoComplete="tel"
                autoFocus
                type="tel"
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
              />
              {validEmail && (
                <p
                  style={{
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                    color: "red",
                    fontWeight: "bold",
                  }}
                >
              המספר הסלולרי כבר תפוס​
                </p>
              )}
              <Button
                fullWidth
                onClick={handleSubmit}
                disabled={!/^05\d{8}$/.test(phoneInput)}
                variant="contained"
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  mt: 3,
                  mb: 2,
				  backgroundColor: 'black',
				  color: 'white',
                }}
              >
                שלח לי את הקוד לסלולר (המתן מספר שניות)
              </Button>
              <ShowDetailSignup text={"אנחנו נשלח לך קוד למספר שתזין כאן, אז מומלץ שזה יהיה מספר בשימושך..."}/>

            </Box>
          )}
         {open && (
            <SimpleBackdrop
              open={open}
              setOpen={setOpen}
              handleClose={handleClose}
              handleToogle={handleToggle}
            />
          )}
          {next && which === "no" && (
            <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
              <OTPInput email={email.current} sentOtp={otp} type={"phone"}progress={progress}setProgress={setProgress}prof={prof.current}/>
            </Box>
          )}
          {direct && which !== "no" && (
            <Next email={email.current} token={token} which={which} type={"phone"}/>
          )}
          <br />
          <Grid container sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
            <Grid item sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
              <NavLink to="/signin" style={{ fontFamily: 'Assistant, sans-serif' }}>כבר יש לך חשבון? התחבר​</NavLink>
            </Grid>
          </Grid>
        </Box>

		{/*(<Copyright sx={{ mt: 8, mb: 4 }} />*/}
      </Container>
	  <Footer />
    </ThemeProvider>
  );
}
